export function isLinkActive(link, activePath) {
  return activePath === link.path || link.nestedAssociatedPaths && link.nestedAssociatedPaths.some(
    (path) => activePath.indexOf(path) === 0
  ) || link.associatedPaths && link.associatedPaths.some((path) => activePath === path);
}
export function isMenuActive(children, activePath) {
  return children.some((link) => isLinkActive(link, activePath));
}
